import { Box, Container, Typography } from "@mui/material";
import { useEffect } from "react";
import { MaintenanceIllustration } from "src/assets";
import { PROJECT_NAME } from "src/config";

// Full-site maintenance page shown for every URL when MAINTENANCE_MODE=true (see src/index.js).
// It renders outside the router and auth providers: no links, redirects or API calls.
export default function MaintenanceMode() {
  useEffect(() => {
    document.title = `Maintenance | ${PROJECT_NAME}`;
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        py: 10,
      }}
    >
      <Container sx={{ textAlign: "center" }}>
        <Typography variant="h3" paragraph>
          Website currently under maintenance
        </Typography>
        <Typography sx={{ color: "text.secondary" }}>
          We are working on improvements. Please check back soon.
        </Typography>

        <MaintenanceIllustration sx={{ my: 10, height: 240 }} />
      </Container>
    </Box>
  );
}
